import { PageLoading } from '../../../components/page';
import { useSubmitSurveyAnalyticsConsentMutation } from '../../../graphQL';
import { useTitle } from '../../../utils/useTitle';
import { SurveyPageWrapper } from './components/SurveyPageWrapper';
import { SurveyStartContent } from './components/SurveyStartContent';
import { useSurveyContext } from './contexts/surveyContext';
import { useSurveyNavigation } from './hooks/useSurveyNavigation';
import { useSurveyStart } from './hooks/useSurveyStart';

export const SurveyStartPage = (): JSX.Element => {
  useTitle(['Student Survey']);

  const surveyNavigation = useSurveyNavigation();
  const { refetchConsent, setHasStarted } = useSurveyContext();
  const surveyStart = useSurveyStart();
  const [submitConsent] = useSubmitSurveyAnalyticsConsentMutation({
    onCompleted: async ({ submitSurveyAnalyticsConsent }) => {
      if (!submitSurveyAnalyticsConsent) {
        return;
      }

      await refetchConsent();
      setHasStarted(true);
      surveyNavigation.goToNext();
    },
  });

  if (surveyStart.loading) {
    return <PageLoading pageName="Survey Start" />;
  }

  const onContinue = async (): Promise<void> => {
    await submitConsent();
  };

  return (
    <SurveyPageWrapper title="Student Survey" testID="survey-start-page">
      <SurveyStartContent
        onContinue={onContinue}
        surveyName={surveyStart.surveyName}
        estimatedCompletionMinutes={surveyStart.estimatedCompletionMinutes}
      />
    </SurveyPageWrapper>
  );
};
